<template>
  <div id="app">
    <GalaxyMap :planets="planets" />
  </div>
</template>

<script>
import apiClient from '@/apiClient';
import GalaxyMap from '../components/GalaxyMap.vue';
import { useHead } from '@unhead/vue';

export default {
  name: 'Planet_Atlas',
  components: {
    GalaxyMap
  },
  data() {
    return {
      planets: [] 
    };
  },
  setup() {
    useHead({
      title: "Star Wars 2D Galaxy Atlas – Explore Planets in an Interactive Grid",
      meta: [
        {
          name: "description",
          content: "Navigate the Star Wars galaxy with our interactive 2D atlas. Discover planets organized in a grid layout, complete with detailed information sourced from Wikidata and Wookieepedia. Perfect for fans and researchers!",
        },
        {
          property: "og:title",
          content: "Star Wars 2D Galaxy Atlas – Explore Planets in an Interactive Grid",
        },
        {
          property: "og:description",
          content: "Explore the Star Wars galaxy through an interactive 2D atlas. Browse planets in a grid layout, enriched with detailed data from Wikidata and Wookieepedia.",
        },
        {
          property: "og:url",
          content: "https://sw-holonet.com/planets/atlas",
        },
        { property: "og:type", content: "website" },
        {
          name: "twitter:title",
          content: "Star Wars 2D Galaxy Atlas – Interactive Grid of Planets",
        },
        {
          name: "twitter:description",
          content: "Discover the Star Wars galaxy with our 2D atlas. Explore planets in a grid layout, featuring detailed data from Wikidata and Wookieepedia.",
        },
        { name: "twitter:card", content: "summary" },
        {
          name: "keywords",
          content: "Star Wars atlas, 2D galaxy map, Star Wars planets, interactive grid, Wikidata Star Wars, Wookieepedia, Star Wars galaxy explorer, planet database",
        },
      ],
    });
  },
  created() {
    this.fetchPlanets(); 
  },
  methods: {
    async fetchPlanets() {
      try {
        const response = await apiClient.get("/api/planets"); 
        this.planets = response.data;
        console.trace(this.planets);
      } catch (error) {
        console.error("Error fetching planets:", error); 
      }
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
